import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/my-shoppers-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark My Shoppers: The New Tool Every Seller Should Benefit From</title>
        <meta
          name='description'
          content='Learn all about this new data-driven feature that leverages likes, bundles, and comments to get you closer to securing sales.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/my-shoppers-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/my-shoppers-poshmark' />
        <meta property='og:title' content='Poshmark My Shoppers: The New Tool Every Seller Should Benefit From' />
        <meta
          property='og:description'
          content='Learn all about this new data-driven feature that leverages likes, bundles, and comments to get you closer to securing sales.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
